import $ from 'jquery';


export default () => {
    (function ($) {
        $(window).on('load resize', function () {
            if ($(window).width() > 1024) {
                var height = $('.negative-margin').find('.title-section').outerHeight();
                $('.negative-margin').css('margin-top', '-' + $('.negative-margin').find('.title-section').outerHeight() + 'px');
            }
        });

    })(jQuery);
};



// WEBPACK FOOTER //
// ./scripts/libs/package.js